import { render } from "./GradBook.vue?vue&type=template&id=f0df82d2&scoped=true"
import script from "./GradBook.vue?vue&type=script&lang=js"
export * from "./GradBook.vue?vue&type=script&lang=js"

import "./GradBook.vue?vue&type=style&index=0&id=f0df82d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0df82d2"]])

export default __exports__